import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { BaseAdvancedFilters } from "./BaseAdvancedFilters";

export class DaysListAdvancedFilter extends BaseAdvancedFilters {
    protected override _constructor(): void {
        super._constructor();

        this.addItems([
            { value: 1, id: "Monday", lockey: "GUI-300874", valueType: "daylist" }, //pondělí
            { value: 2, id: "Tuesday", lockey: "GUI-300876", valueType: "daylist" }, //úterý
            { value: 3, id: "Wednesday", lockey: "GUI-300878", valueType: "daylist" }, //středa
            { value: 4, id: "Thursday", lockey: "GUI-300880", valueType: "daylist" }, //čtvrtek
            { value: 5, id: "Friday", lockey: "GUI-300882", valueType: "daylist" }, //pátek
            { value: 6, id: "Saturday", lockey: "GUI-300884", valueType: "daylist" }, //sobota
            { value: 0, id: "Sunday", lockey: "GUI-300886", valueType: "daylist" }, //neděle
        ]);
    }
}

registerCustomElement("tsc-DaysListAdvancedFilter", DaysListAdvancedFilter);
